import React from 'react';
import IconDelete from 'assets/apply.clevry/Icon_Delete.png';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

type MatchingProcessDeleteIconProps = {
  onClick: () => void;
};

export const MatchingProcessDeleteIcon = ({
  onClick,
}: MatchingProcessDeleteIconProps) => {
  const { t } = useTranslation('Matching+Process', { i18n });

  return (
    <div className="MatchingProcessDeleteIcon" onClick={onClick}>
      <img src={IconDelete} alt={t('SSCandidate_Matching_Process_Alt_Delete_Icon')} />
    </div>
  );
};
